/**
 * framer-motion variants shared by both apps' ResponsiveSheet shells.
 * Identical timings = identical perceived motion across web + portal.
 */

import { SHEET_BACKDROP_DURATION_S, SHEET_SPRING } from "./tokens";

export const backdropVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: SHEET_BACKDROP_DURATION_S },
  },
  exit: {
    opacity: 0,
    transition: { duration: SHEET_BACKDROP_DURATION_S },
  },
} as const;

/**
 * Mobile bottom-sheet enter/exit. y: "100%" lets framer-motion translate
 * relative to the panel height, so it slides off below the fold regardless
 * of how tall the panel ends up at runtime.
 */
export const bottomSheetVariants = {
  hidden: { y: "100%" },
  visible: {
    y: 0,
    transition: SHEET_SPRING,
  },
  exit: {
    y: "100%",
    transition: { duration: 0.22, ease: [0.32, 0, 0.67, 0] as const },
  },
} as const;

/** Centered desktop dialog: scale + fade. Snappy out-expo curve on enter
 * (fast start, soft settle) and quick fade on exit — keeps modal feedback
 * under perceptual lag threshold. */
export const dialogVariants = {
  hidden: { opacity: 0, scale: 0.96, y: 8 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { duration: 0.14, ease: [0.16, 1, 0.3, 1] as const },
  },
  exit: {
    opacity: 0,
    scale: 0.97,
    y: 6,
    transition: { duration: 0.1, ease: [0.4, 0, 1, 1] as const },
  },
} as const;

/** Right-anchored side sheet (desktop tablet variant). */
export const sideSheetVariants = {
  hidden: { x: "100%" },
  visible: {
    x: 0,
    transition: SHEET_SPRING,
  },
  exit: {
    x: "100%",
    transition: { duration: 0.16, ease: [0.32, 0, 0.67, 0] as const },
  },
} as const;
